import { IResponsiveComponentLayoutConfig } from '@faire/web-api--source/indigofair/data/IResponsiveComponentLayoutConfig';

export namespace IResponsiveComponentLayoutConfigs {
  /**
   * Return an instance of IResponsiveComponentLayoutConfigs with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IResponsiveComponentLayoutConfigs>
  ): IResponsiveComponentLayoutConfigs =>
    ({
      mobile_and_above: [],
      tablet_and_above: [],
      desktop_and_above: [],
      x_large_and_above: [],
      ...(partial ?? {}),
    }) as IResponsiveComponentLayoutConfigs;
}

/**
 * end of protos for SDUI Tool page
 * Responsive layout info at component level for all screen sizes
 */
export interface IResponsiveComponentLayoutConfigs {
  mobile_and_above: Array<IResponsiveComponentLayoutConfig>;
  tablet_and_above: Array<IResponsiveComponentLayoutConfig>;
  desktop_and_above: Array<IResponsiveComponentLayoutConfig>;
  x_large_and_above: Array<IResponsiveComponentLayoutConfig>;
}
